"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetDataSourcePrioritizer = void 0;
const p_queue_1 = __importDefault(require("p-queue"));
/**
 * A class that prioritizes widget data sources based on the priority of the data source
 * and ensures that only N requests is made at a time for a given widget data source.
 */
class WidgetDataSourcePrioritizer {
    queue;
    dashboardDataSource;
    /**
     * Key is widget type + ":" + widget id + ":" + priority
     */
    widgetDataSources;
    constructor(dashboardDataSource, concurrency) {
        this.dashboardDataSource = dashboardDataSource;
        this.queue = new p_queue_1.default({ concurrency: concurrency });
        this.widgetDataSources = {};
    }
    /** Get a widget data source with the given priority */
    getWidgetDataSource(widgetType, widgetId, priority) {
        let widgetDataSource = this.widgetDataSources[widgetType + ":" + widgetId + ":" + priority];
        if (!widgetDataSource) {
            const innerWidgetDataSource = this.dashboardDataSource.getWidgetDataSource(widgetType, widgetId);
            widgetDataSource = {
                getData: (design, filters, callback) => {
                    const task = () => new Promise((resolve, reject) => {
                        innerWidgetDataSource.getData(design, filters, (error, data) => {
                            if (error) {
                                callback(error);
                                reject(error);
                            }
                            else {
                                callback(null, data);
                                resolve(data);
                            }
                        });
                    });
                    // Create an abort controller for this task
                    const taskAbortController = new AbortController();
                    // Queue the task and handle errors
                    this.queue.add(task, { priority: priority, signal: taskAbortController.signal }).catch((e) => {
                        console.log("Task failed", e);
                        callback(e);
                    });
                    return taskAbortController;
                },
                /** Get the url to download an image (by id from an image or imagelist column)
                  * Height, if specified, is minimum height needed. May return larger image */
                getImageUrl: (imageId, height) => {
                    return innerWidgetDataSource.getImageUrl(imageId, height);
                }
            };
            if (innerWidgetDataSource.getMapDataSource) {
                widgetDataSource.getMapDataSource = (design) => {
                    return innerWidgetDataSource.getMapDataSource(design);
                };
            }
            this.widgetDataSources[widgetType + ":" + widgetId + ":" + priority] = widgetDataSource;
        }
        return widgetDataSource;
    }
    cancel() {
        // Clear the queue
        this.queue.clear();
    }
}
exports.WidgetDataSourcePrioritizer = WidgetDataSourcePrioritizer;
